import { Clock } from "lucide-react";

interface ComingSoonPageProps {
  title: string;
  description?: string;
}

export function ComingSoonPage({ title, description }: ComingSoonPageProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <div className="h-16 w-16 rounded-2xl bg-white border border-[#E5E2DC] flex items-center justify-center mb-5">
        <Clock className="h-8 w-8 text-[#746F66]" />
      </div>
      <h1 className="text-2xl font-bold text-[#1A1A1A] mb-2">{title}</h1>
      <p className="text-[#746F66] max-w-sm text-sm leading-relaxed">
        {description ?? "This feature is coming soon. Check back for updates."}
      </p>
      <span className="mt-6 px-3 py-1 text-xs font-semibold rounded-full bg-white border border-[#E5E2DC] text-[#746F66] uppercase tracking-wide">
        Coming Soon
      </span>
    </div>
  );
}
